module.exports = __webpack_public_path__ + "img/no_goals_in_dream.c37a89ef.svg";